import { useState, useCallback } from "react";
import { useQuery } from "@tanstack/react-query";
import { getOtherAreas } from "../actions/getOtherAreas";
import { PaginatedOtherAreasResponse } from "../interfaces/otherAreas.interface";

interface UseOtherAreasPaginationParams {
  pageSize?: number;
  category?: string;
  typeOfService?: string;
}

export const useOtherAreasPagination = ({
  pageSize = 10,
  category,
  typeOfService
}: UseOtherAreasPaginationParams) => {

  const [page, setPage] = useState(1);

  const enabled =
    Boolean(category) &&
    Boolean(typeOfService);

  const query = useQuery<PaginatedOtherAreasResponse>({
    queryKey: [
      "otherAreas-paginated",
      category,
      typeOfService,
      page,
      pageSize
    ],
    queryFn: () =>
      getOtherAreas({
        page,
        pageSize,
        categoryUid: category!,
        typeOfService: typeOfService!,
      }),
    enabled,
    staleTime: 60000,
  });

  const totalPages = query.data?.totalPages ?? 1;

  const goNextPage = useCallback(() => {
    setPage((prev) => (prev < totalPages ? prev + 1 : prev));
  }, [totalPages]);

  const goPrevPage = useCallback(() => {
    setPage((prev) => (prev > 1 ? prev - 1 : prev));
  }, []);

  const resetPagination = useCallback(() => {
    setPage(1);
  }, []);

  return {
    ...query,

    page,
    totalPages,
    totalItems: query.data?.totalItems ?? 0,
    items: query.data?.items ?? [],

    goNextPage,
    goPrevPage,
    resetPagination,

    isLastPage: page >= totalPages,
  };
};
